(function () {
  "use strict";

  class LoadMoreProduct extends HTMLElement {
    constructor() {
      super();
      this._onClick = this.onClickLoadMore.bind(this);
      this.addEventListener("click", this._onClick);
      this._loading = false;
    }

    disconnectedCallback() {
      try { this.removeEventListener("click", this._onClick); } catch (e) {}
    }

    async onClickLoadMore(evt) {
      try {
        // łap klik na przycisk lub jego child
        const btn = evt.target.closest(".loadMoreBtn");
        if (!btn || !this.contains(btn)) return;

        evt.preventDefault();

        // blokada wielokliku
        if (this._loading) return;
        this._loading = true;

        const currentPage = parseInt(btn.dataset.currentPage, 10);
        const collectionUrl = btn.dataset.url;
        const sectionId = btn.dataset.sectionId;

        if (!Number.isFinite(currentPage) || !collectionUrl || !sectionId) {
          this._loading = false;
          return;
        }

        const productWrapper = this.querySelector(".collection__product");
        const loadMoreBtnWrapper = this.querySelector(".loadMoreWrapper");

        if (!productWrapper || !loadMoreBtnWrapper) {
          this._loading = false;
          return;
        }

        btn.classList.add("loading");
        btn.setAttribute("aria-busy", "true");

        const nextUrl = `${collectionUrl}?page=${currentPage + 1}&section_id=${encodeURIComponent(sectionId)}`;

        const response = await fetch(nextUrl, { credentials: "same-origin" });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const resText = await response.text();
        const doc = new DOMParser().parseFromString(resText, "text/html");

        // produkty
        const loadedProductWrap = doc.querySelector(".collection__product");
        if (loadedProductWrap && loadedProductWrap.innerHTML.trim()) {
          productWrapper.insertAdjacentHTML("beforeend", loadedProductWrap.innerHTML);
        } else {
          // jeśli nie ma produktów, to usuń przycisk (koniec paginacji)
          loadMoreBtnWrapper.innerHTML = "";
          return;
        }

        // przycisk / wrapper
        const loadedBtnWrap = doc.querySelector(".loadMoreWrapper");
        loadMoreBtnWrapper.innerHTML = loadedBtnWrap ? loadedBtnWrap.innerHTML : "";

        // update strony w dataset (czasem przycisk zostaje ten sam)
        // jeśli nowy przycisk jest renderowany, to on ma już dataset
      } catch (error) {
        console.warn("[load-more-product] error:", error);
      } finally {
        try {
          const btn = this.querySelector(".loadMoreBtn.loading");
          if (btn) {
            btn.classList.remove("loading");
            btn.removeAttribute("aria-busy");
          }
        } catch (e) {}

        this._loading = false;
      }
    }
  }

  try {
    if (!customElements.get("load-more-product")) {
      customElements.define("load-more-product", LoadMoreProduct);
    }
  } catch (e) {}
})();
